import {
  TicketDiscountType,
  TicketItemType,
  TicketModifierOptionsType,
} from '../../redux/data/dataTypes';
import api from '../axios/axiosInstance';

export interface invoiceForm {
  ID: string;
  items?: TicketItemType[];
  discounts?: TicketDiscountType[];
  modifierOptions?: TicketModifierOptionsType[];
  category?: 'IN' | 'OUT' | 'DELIVERY';
  payType: 'CASH' | 'CARD' | 'BOTH' | 'CREDIT';
  type: 'PAY' | 'REFUND';
  currency: string;
  total: number;
  number: number;
  shiftId: string;
  posId: string;
  storeId?: string;
  createdAt: Date | string;
  originalInvoiceId?: string;
  customerId?: string | null;
}

export interface sendInvoiceForm {
  ID: string;
  email: string;
}
const submitInvoice = async (data: invoiceForm): Promise<any> => {
  return api.post('/invoices', data);
};

const sendInvoicePdf = async (data: sendInvoiceForm): Promise<any> => {
  return api.post('/invoices/send', data);
};

export { sendInvoicePdf, submitInvoice };
